import { BehaviorSubject, Observable, combineLatest, of } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { catchError, map, switchMap } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SearchBarComponent } from '../search-bar/search-bar.component';
import { SelectedCompanyService } from '@src/app/services/selected-company-service/selected-company.service';
import { SpinnerComponent } from '../spinner/spinner.component';
import { ZonarUIMaterialModule } from '@zonar-ui/material';
import { ZonesApiService } from '@src/app/services/zones-api/zones-api.service';

@Component({
  selector: 'app-category-content',
  standalone: true,
  imports: [
    CommonModule,
    ZonarUIMaterialModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    SearchBarComponent,
    SpinnerComponent,
  ],
  templateUrl: './category-content.component.html',
  styleUrls: ['./category-content.component.scss']
})
export class CategoryContentComponent implements OnInit {
  categories$: Observable<{ color: string; name: string }[]>;
  searchTerm$ = new BehaviorSubject<string>('');
  error: string | null = null;

  constructor(
    private currentCompany$: SelectedCompanyService,
    private zonesApiService: ZonesApiService,
  ) { }

  ngOnInit(): void {
    this.categories$ =this.currentCompany$.getCurrentCompany().pipe(
      switchMap((companyId) => {
        return combineLatest([
          this.getCategories(companyId),
          this.searchTerm$.asObservable(),
        ])
      }),
      map(([categories, searchTerm]) => {
        return categories.filter(({ name }) => name.toLowerCase().trim().includes(searchTerm.toLowerCase().trim()))
      }),
      catchError(error => {
        this.error = error?.statusText || 'Something went wrong!';
        return of([]);
      })
    )
  }

  onSearch(text: string) {
    this.searchTerm$.next(text);
  }

  selectCategory(category) {
    console.log('category', category);
  }

  createCategory() {
    console.log('createCategory');
  }

  getCategories(companyId: string) {
    return this.zonesApiService.getCategories(companyId);
  }

  getStyles(category) {
    return {
      'backgroundColor': category.color,
      'visibility': {'hide': !category.color},
    }
  }
}
